import React, {useEffect, useState} from 'react';
import './App.css';
import './styles/css/antd.css';
import {Routes, Route, useNavigate, useSearchParams, useParams, useLocation} from 'react-router-dom';
import AppContext from "./utilis/contexts/AppContext";
import AuthContext from "./utilis/contexts/AuthContext";
import MyTransactions from "./pages/MyTransactions"
import Home from "./pages/Home";
import Layout from "./components/Layout";
import Service from "./pages/Service";
import FormSelector from "./pages/FormSelector";
import WorkFlow from "./pages/WorkFlow";
import Login from "./pages/Login";
import {generateDeviceId} from "./utilis/helpers/generators";
import LocalStorage from "./utilis/tools/LocalStorage";
import Panel from "./pages/Panel";
import ServiceList from "./pages/ServiceList";
import LoadingScreen from "./components/LoadingScreen";
import Dashboard from "./pages/Dashboard";
import branchInfo from "./utilis/models/branchInfo";
import token from "./utilis/models/token";
import Api from "./utilis/api/service";
import Urls from "./utilis/api/Urls";
import axios, {AxiosError, AxiosResponse} from "axios";
import {notification} from "antd";
import {serviceFormData} from "./utilis/api/GlobalServices";
import UserRequests from "./pages/UserRequests";
import Token from "./utilis/models/token";
import BillView from "./pages/BillView";
import ManageFiles from "./pages/ManageFiles";
import MyRequests from "./pages/MyRequests";
import Bills from "./pages/Bills";
import PaymentHistory from "./pages/PaymentHistory";
import TrackPaymentBills from "./pages/TrackPaymentBills";
import FindWorkFlow from "./pages/FindWorkFlow";
import BillPayment from "./pages/BillPayment";
import Accident from "./pages/Accident";
import RegisterLetter from "./pages/RegisterLetter";
import RegisterLetterLayout from "./components/register-letter/RegisterLetterLayout";
import Tracking from "./components/register-letter/Tracking";

function App() {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<any>(LocalStorage.getUser());
    const [currentFileNumber, setCurrentFileNumber] = useState<any>(LocalStorage.getFileNumber());
    const [currentBranchInfo, setCurrentBranchInfo] = useState<branchInfo>(new branchInfo());
    const [addBranchModalOpen, setOpenAddBranchModal] = useState(false)
    const handleOpenModal = (value: boolean) => setOpenAddBranchModal(value)
    const [searchParams, setSearchParams] = useSearchParams();
    const [accessToken, setAccessToken] = useState<token>(LocalStorage.getToken() != "" ? LocalStorage.getToken() : new token());
    const [branches, setBranches] = useState([]);
    const [globalData, setGlobalData] = useState<any>(LocalStorage.getFormData())
    const [data, setData] = useState<any>(LocalStorage.getData());
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const handleBranches = (branches: any) => {
        setBranches(branches);
    }
    const handleCurrentFileNumber = (fileNumber: any) => {
        setCurrentFileNumber(fileNumber);
    }
    const handleCurrentBranchInfo = (branchInfo: branchInfo) => {
        setCurrentBranchInfo(branchInfo);
    }
    const handleLoading = (value: boolean) => {
        setLoading(value);
    }
    const handleGlobalData = (value: any) => {
        setGlobalData(value);
    }
    const handleData = (value: any) => {
        setData(value)
    }
    const handleUser = (value: any) => {
        setUser(value);
    }
    const handleLogout = () => {

        setUser(null)
        LocalStorage.clearUser();
        LocalStorage.clearBranchInfo();
        LocalStorage.clearFileNumber();
        if(location.pathname==='/panel/letter/register-letter'){
            navigate('/login?register_letter=true')
        }else {
            navigate('/login')
        }

    }
    const handleAccessToken = (value: any) => {
        setAccessToken(new Token(value))
    }
    const handleBranchInfo = (fileNum: string) => {

        handleLoading(true)
        Api.post(Urls.getBranchInfo, {
            Cellphone: user.cellphone,
            FileNumber: fileNum
        }, {
            headers: {
                "Authorization": accessToken.tokenType + " " + accessToken.accessToken
            }
        }).then((response: AxiosResponse) => {

            const {data} = response;
            const {Data, Status} = data;
            const {branches, branch_info} = Data;
            if (Status === 0) {
                LocalStorage.setFileNumber(fileNum);
                handleCurrentFileNumber(fileNum)
                handleCurrentBranchInfo(Object.keys(branch_info).length === 0 ? new branchInfo() : branch_info)
                handleBranches(branches)
                handleCurrentFileNumber(fileNum)
                navigate('/panel')
            }

        }).catch((e: AxiosError) => {

        }).finally(() => {
            handleLoading(false)
        })

    }

    useEffect(() => {
        if (LocalStorage.getDeviceId() === "" || LocalStorage.getDeviceId()) {

            generateDeviceId();
        }
    }, [])
    useEffect(() => {
        if (searchParams.get("token")) {
            //portal
               handleUser(null)
               handleData(null)
            handleLoading(true);
            axios.get(Urls.root + Urls.RedirectUser + searchParams.get("token"), {}).then((response: AxiosResponse) => {
                const {data} = response;
                const {Data, Status, Message} = data;
                if (Status === -1) {
                    notification['error']({
                        message: Message,
                        duration: 120
                    });
                    navigate('/404')

                } else if (Data) {

                    const {branch} = Data;
                    LocalStorage.setToken({
                        token_type: 'Bearer ',
                        access_token: branch.access_token
                    })
                    LocalStorage.setData({
                        data: branch,
                        token: searchParams.get("token"),
                    });
                    LocalStorage.setBranchInfo(branch);
                    LocalStorage.clearUser()
                    handleUser(null);
                    const {service_type} = branch;
                    handleData({
                        data: branch,
                        token: searchParams.get("token"),
                    });
                    serviceFormData((gData, data) => {
                        handleGlobalData(gData);
                        navigate(`/service/${service_type}`+`${searchParams.get("token")?'?isPortal=true' :''}`);
                        handleLoading(false)
                    })


                }
            }).catch((error) => {
                handleLoading(false)
            }).finally(() => {

            })
        } else if (!!user) {
            //authenticated
            handleLoading(true);
            serviceFormData((gData, data) => {
                handleGlobalData(gData);
                handleLoading(false);
            })
            if (location.pathname === "/")
                navigate('/panel');
        } else {
            handleLoading(false)
            if(location.pathname === "/panel/letter/register-letter"){
                navigate('/login?register_letter=true');
            }else {
                navigate('/login');
            }


        }


    }, [])



    return (
        <AuthContext.Provider value={{
            user: user,
            loading,
            authenticated: !!user,
            data: data,
            Token: accessToken,
            handleAccessToken: handleAccessToken,
            logout: handleLogout,
            handleData: handleData,
            handleUser: handleUser,
            handleBranches: handleBranches,
            currentFileNumber: currentFileNumber,
            handleCurrentFileNumber: handleCurrentFileNumber,
            currentBranchInfo: currentBranchInfo,
            handleCurrentBranchInfo: handleCurrentBranchInfo,
            handleBranchInfo: handleBranchInfo,
            addBranchModalOpen: addBranchModalOpen,
            handleAddBranchModal: handleOpenModal,
            branches: branches,
            login: () => {
            },


        }}>
            <AppContext.Provider value={{
                isLoading: loading,
                handleLoading: handleLoading,
                globalData: globalData,
                handleGlobalData: handleGlobalData,
            }}>
                {loading && <LoadingScreen/>}

                <Routes>

                    <Route path="/" element={<Layout/>}>
                        <Route path={`/login`} element={<Login/>}/>
                        <Route path={`/panel`} element={<Panel/>}>
                            <Route index element={<Dashboard/>}/>
                            <Route path="letter" element={<RegisterLetterLayout/>}>
                                <Route path="register-letter" element={<RegisterLetter/>} />
                                <Route path="tracking-letter" element={<Tracking/>} />
                            </Route>

                            <Route path="services" element={<ServiceList/>}/>
                            <Route path="MyRequests" element={<MyRequests/>}/>
                            <Route path="manageFiles" element={<ManageFiles/>}/>
                            <Route path=":serviceType" element={<FormSelector/>}/>
                            <Route path="bills" element={<Bills/>}/>
                            <Route path="paymentHistory" element={<PaymentHistory/>}/>
                            <Route path="userRequests" element={<UserRequests/>}/>
                            <Route path="MyTransactions" element={<MyTransactions/>}/>
                            <Route path={`Workflow`} element={<WorkFlow/>}/>
                            <Route path={`findWorkFlow`} element={<FindWorkFlow/>}/>
                            <Route path={`TrackPaymentBills`} element={<TrackPaymentBills/>}/>
                        </Route>
                        <Route path="billView" element={<BillView/>}/>
                        <Route path={`/trace`} element={<WorkFlow/>}/>
                        <Route path={`/HavadesAbfa`} element={<Accident/>}/>
                        <Route path={`/billPayment`} element={<BillPayment/>}/>
                        <Route path={`/service`} element={<Service/>}>
                            <Route path=":serviceType" element={<FormSelector/>}/>
                        </Route>

                    </Route>

                </Routes>

            </AppContext.Provider>
        </AuthContext.Provider>

    );
}

export default App;
